import React, { useRef, useState } from "react";
import { useTranslation } from "next-i18next";

import { InputCode, InputCodeHandle } from "components/Inputs/InputCode";
import { useValidatePinCode } from "hooks/useValidatePinCode";

import styles from "./EnterPinCodeForm.module.scss";

interface IEnterPinCodeFormProps {
  pinCodeId?: string;
  onSuccess: () => void;
}

export const EnterPinCodeForm = ({
  pinCodeId,
  onSuccess,
}: IEnterPinCodeFormProps) => {
  const { t } = useTranslation("translations");
  const [code, setCode] = useState<string[]>([]);
  const inputRef = useRef<InputCodeHandle>(null);

  const validation = useValidatePinCode({
    onSuccess,
    onError: () => {
      setCode([]);
      inputRef.current?.focus();
    },
  });

  const onChange = (value: string[]) => {
    setCode(value);

    if (validation.error) {
      validation.reset();
    }
  };

  const onComplete = (pinCode: string) => {
    if (!validation.isLoading) {
      validation.mutate({ pinCodeId, pinCode });
    }
  };

  return (
    <InputCode
      ref={inputRef}
      value={code}
      type="password"
      error={validation.error ? t("web_subprofiles_pin_error") : undefined}
      autoFocus
      className={styles.inputCode}
      onChange={onChange}
      onComplete={onComplete}
    />
  );
};
